import { EnterpriseApi } from "./api";

export type MetabotUsageResponse = {
  tokens: number | null;
  "updated-at": string | null;
};

export const metabotApi = EnterpriseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMetabotUsage: builder.query<MetabotUsageResponse, void>({
      query: () => ({
        method: "GET",
        url: "/api/ee/metabot/usage",
      }),
    }),
  }),
});

export const { useGetMetabotUsageQuery } = metabotApi;
